import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useNavigate } from 'react-router-dom';

export type menuAccessToDossierType = {
    dossierId: number;
    dossiersBasePath: string;
};
const MenuAccessToDossier: React.FunctionComponent<menuAccessToDossierType> = function ({
    dossierId,
    dossiersBasePath = 'dossiers',
}) {
    const navigate = useNavigate();

    const handleDossierLinkClick = () => {
        navigate(`/${dossiersBasePath}/${dossierId}?dossier-detail=details`);
    };

    return (
        <MenuItem
            sx={{ gap: '4px' }}
            onClick={handleDossierLinkClick}
        >
            <FaOptionIcon
                icon={['fasl', 'file-lines']}
                color="text.gris70"
            />
            <Typography sx={{ color: 'text.primary' }}>Accéder au dossier</Typography>
        </MenuItem>
    );
};

export default MenuAccessToDossier;
